var createStylesheet = (chunkId, fullhref, resolve, reject) => {
	var linkTag = document.createElement("link");

	linkTag.rel = "stylesheet";
	linkTag.type = "text/css";
	var onLinkComplete = (event) => {
		// avoid mem leaks.
		linkTag.onerror = linkTag.onload = null;
		if (event.type === 'load') {
			resolve();
		} else {
			var errorType = event && (event.type === 'load' ? 'missing' : event.type);
			var realHref = event && event.target && event.target.href || fullhref;
			var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + realHref + ")");
			err.code = "CSS_CHUNK_LOAD_FAILED";
			err.type = errorType;
			err.request = realHref;
			linkTag.parentNode.removeChild(linkTag)
			reject(err);
		}
	}
	linkTag.onerror = linkTag.onload = onLinkComplete;
	linkTag.href = fullhref;

	(function(linkTag) {
	                if (typeof _N_E_STYLE_LOAD === 'function') {
	                    const { href, onload, onerror } = linkTag;
	                    _N_E_STYLE_LOAD(href.indexOf(window.location.origin) === 0 ? new URL(href).pathname : href).then(()=>onload == null ? void 0 : onload.call(linkTag, {
	                            type: 'load'
	                        }), ()=>onerror == null ? void 0 : onerror.call(linkTag, {}));
	                } else {
	                    document.head.appendChild(linkTag);
	                }
	            })(linkTag)
	return linkTag;
};
var findStylesheet = (href, fullhref) => {
	var existingLinkTags = document.getElementsByTagName("link");
	for(var i = 0; i < existingLinkTags.length; i++) {
		var tag = existingLinkTags[i];
		var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
		if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return tag;
	}
	var existingStyleTags = document.getElementsByTagName("style");
	for(var i = 0; i < existingStyleTags.length; i++) {
		var tag = existingStyleTags[i];
		var dataHref = tag.getAttribute("data-href");
		if(dataHref === href || dataHref === fullhref) return tag;
	}
};
var loadStylesheet = (chunkId) => {
	return new Promise((resolve, reject) => {
		var href = __webpack_require__.miniCssF(chunkId);
		var fullhref = __webpack_require__.p + href;
		if(findStylesheet(href, fullhref)) return resolve();
		createStylesheet(chunkId, fullhref, resolve, reject);
	});
}
// object to store loaded CSS chunks
var installedCssChunks = {
	8068: 0
};

__webpack_require__.f.miniCss = (chunkId, promises) => {
	var cssChunks = {"4":1,"14":1,"41":1,"310":1,"470":1,"477":1,"519":1,"699":1,"1058":1,"1142":1,"1145":1,"1162":1,"1178":1,"1186":1,"1278":1,"1479":1,"1544":1,"1710":1,"1834":1,"1886":1,"1892":1,"1991":1,"2062":1,"2153":1,"2189":1,"2246":1,"2250":1,"2346":1,"2399":1,"2405":1,"2406":1,"2797":1,"2829":1,"2894":1,"3364":1,"3378":1,"3452":1,"3489":1,"3670":1,"3680":1,"3714":1,"3738":1,"3828":1,"3860":1,"4014":1,"4029":1,"4114":1,"4207":1,"4234":1,"4292":1,"4324":1,"4330":1,"4342":1,"4459":1,"4464":1,"4582":1,"4758":1,"4798":1,"4818":1,"4838":1,"5006":1,"5192":1,"5223":1,"5268":1,"5330":1,"5375":1,"5570":1,"5625":1,"5702":1,"5711":1,"5758":1,"5774":1,"5873":1,"6044":1,"6136":1,"6200":1,"6226":1,"6343":1,"6374":1,"6399":1,"6411":1,"6422":1,"6446":1,"6510":1,"6575":1,"6578":1,"6688":1,"6742":1,"6768":1,"6771":1,"6788":1,"6837":1,"6892":1,"6929":1,"6996":1,"7058":1,"7110":1,"7192":1,"7207":1,"7220":1,"7468":1,"7543":1,"7652":1,"7662":1,"7844":1,"7853":1,"7891":1,"7919":1,"7929":1,"8000":1,"8028":1,"8110":1,"8158":1,"8189":1,"8220":1,"8432":1,"8475":1,"8518":1,"8571":1,"8635":1,"8720":1,"8730":1,"8788":1,"8813":1,"8822":1,"8882":1,"8894":1,"8997":1,"9063":1,"9266":1,"9283":1,"9492":1,"9643":1,"9702":1,"9985":1};
	if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
	else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
		promises.push(installedCssChunks[chunkId] = loadStylesheet(chunkId).then(() => {
			installedCssChunks[chunkId] = 0;
		}, (e) => {
			delete installedCssChunks[chunkId];
			throw e;
		}));
	}
};

// no hmr